import React, { useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";

import i18n from "./i18n";
import ApplicationLayout from "./layout/Layout";
import store from "./redux/store";
import { addLocale } from 'primereact/api';

import "./App.css";

function App() {
  i18n.on("languageChanged init", () => {
    document.body.dir = i18n.dir();
  });

  useEffect(() => {
    localStorage.setItem("i18nextLng", "ar");
    document.body.dir =
      localStorage.getItem("i18nextLng") === "ar" ? "rtl" : "ltr";
    document.body.dir = i18n.dir();

    // Select the node that will be observed for mutations
    const targetNode = document.getElementById("root");

    // Options for the observer (which mutations to observe)
    const config = { childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (let item of document.getElementsByTagName("input")) {
        item.setAttribute("autocomplete", "off");
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);

    // Later, you can stop observing
    return () => {
      observer.disconnect();
      localStorage.removeItem("i18nextLng");
    };
  }, []);

  useEffect(()=>{
    addLocale('ar', {
      firstDayOfWeek: 6,
      dayNames: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
      dayNamesShort: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
      dayNamesMin: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
      // dayNamesMin: ['س', 'أح', 'إث', 'ثلا', 'أر', 'خ', 'ج'],
      monthNames: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
      monthNamesShort: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
      // monthNamesShort: ['ينا', 'فبر', 'مار', 'أبر', 'ماي', 'يون', 'يول', 'أغس', 'سبت', 'أكت', 'نوف', 'ديس'],
      today: 'اليوم',
      clear: 'مسح',
  });
  }, [])

  return (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <ApplicationLayout />
      </Provider>
    </I18nextProvider>
  );
}

export default App;
